
import AuthService from '@/services/support/AuthService'
import LogService, { ToString } from '@/services/support/LogService'
import { License } from '@/types/catalogs/Licenses'
import Vue from 'vue'
import SessionCard from './SessionCard.vue'

export default Vue.extend({
  components: {
    SessionCard
  },
  props: {
    domain: {
      type: String,
      required: true
    },
    username: {
      type: String,
      required: true
    },
    password: {
      type: String,
      required: true
    },
    loadSessions: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data () {
    return {
      inviteToLoginMessage: false as boolean,
      userSessions: [] as Array<License>,
      sessionDeleted: false as boolean
    }
  },
  computed: {
    userCredentials (): { username: string, password: string } {
      return {
        username: `${this.username}@${this.domain}`,
        password: this.password
      }
    },
    hasUserSessions (): boolean {
      return this.userSessions.length > 0
    }
  },
  watch: {
    loadSessions (newValue: boolean, oldValue: boolean): void {
      if (!oldValue && newValue) this.getSessions()
    }
  },
  methods: {
    /**
     * Emit the event to close this component
     */
    closeUnlockSessions (): void {
      this.setSessionDeleted(false)
      this.$emit('close-unlock-sessions')
    },
    /**
     * Get the request to obtain all the sessions belong to the user.
     */
    getSessions (): void {
      const credentials = this.userCredentials
      AuthService.getUserSessions(credentials)
        .then((response) => {
          this.userSessions = response.results
          this.setSessionDeleted(false)
        })
        .catch((error) => {
          LogService.error(`Error al obtener las sesiones: ${ToString(error.response ?? error)}`)
        })
    },
    /**
     * Set the 'value' to the 'sessionDeleted' variable
     *
     * @param value to set
     */
    setSessionDeleted (value: boolean): void {
      this.sessionDeleted = value
    },
    /**
     * Get the index from the current user sessions list
     *
     * @param sessionId id of the session to get
     */
    indexSessionFromList (sessionId: number): number {
      return this.userSessions.findIndex((sess) => sess.id === sessionId)
    },
    /**
     * Removes one session identified by its id.
     *
     * @param sessionId id of the session to remove from the current list
     */
    removeSession (sessionId: number): void {
      const sessinIndex = this.indexSessionFromList(sessionId)
      if (sessinIndex !== -1) {
        this.userSessions.splice(sessinIndex, 1)
        this.setSessionDeleted(true)
      }
    }
  }
})
